import { render, staticRenderFns } from "./FirmaPassword.vue?vue&type=template&id=0a9fd8a7&scoped=true&"
import script from "./FirmaPassword.vue?vue&type=script&lang=js&"
export * from "./FirmaPassword.vue?vue&type=script&lang=js&"
import style0 from "./FirmaPassword.vue?vue&type=style&index=0&id=0a9fd8a7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9fd8a7",
  null
  
)

export default component.exports